<script>
  import { openOverpanel } from '../../stores/overpanelControl';
  import { SPRITESHEET_URL } from '../../utils/constants';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { accessCode } from '../../stores/referrer';

  let {
    instructionText,
    textCardButtonText,
    emailCardButtonText,
    moreOptionsButtonText,
    fewerOptionsButtonText,
    openInAppLink,
    printCardLinkText,
    disclaimer,
    reducedPadding = false,
    textCardButtonOnClickCallback = () => {},
    emailCardButtonOnClickCallback = () => {},
    dataTestId = 'get-card-tile',
  } = $props();

  let expanded = $state(false);
  const handleTextCardButtonClicked = () => {
    openOverpanel('textCard');
    textCardButtonOnClickCallback();
    window.umami.track('get-savings-card', { type: 'text' });
  };

  const handleEmailCardButtonClicked = () => {
    openOverpanel('emailCard');
    emailCardButtonOnClickCallback();
    window.umami.track('get-savings-card', { type: 'email' });
  };

  const print = () => {
    window.umami.track('get-savings-card', { type: 'print' });
    window.print();
  };

  const toggle = () => (expanded = !expanded);

  let appStoreLink = $derived($accessCode ? `${openInAppLink.url}?source=${$accessCode}` : openInAppLink.url);
</script>

<div
  class="print:hidden w-full"
  class:bg-transparent={reducedPadding}
  class:bg-white={!reducedPadding}
  class:lg:px-4={!reducedPadding}
  class:lg:bg-white={!reducedPadding}
  class:lg:shadow-md={!reducedPadding}
  class:pt-30={!reducedPadding}
  class:pb-7={!reducedPadding}
  class:lg:pb-6={!reducedPadding}
  class:lg:pt-6={!reducedPadding}
  class:pt-4={reducedPadding}
  class:md:pt-8={reducedPadding}
  class:lg:pt-0={reducedPadding}
>
  <div
    class="px-4 sm:px-0 text-center mx-auto max-w-106 xl:px-4 lg:max-w-6xl"
    class:lg:px-4={reducedPadding}
    class:grid={!reducedPadding}
    class:lg:grid-cols-3={!reducedPadding}
    data-testid={dataTestId}
  >
    <div class="lg:max-w-65 mb-4 lg:mb-0 lg:mr-12" class:lg:hidden={reducedPadding}>
      <p class="mx-auto text-base lg:text-lg lg:text-left leading-tight text-blue-navy lg:mb-4">{instructionText}</p>
    </div>
    <div class="lg:grid lg:grid-cols-2 lg:col-span-2">
      <div class="grid gap-4 mx-auto max-w-85 [@media(min-width:380px)]:grid-cols-2 sm:grid-cols-2 lg:w-full lg:max-w-none lg:gap-6 lg:ml-0" class:mb-6={disclaimer}>
        <button
          class="whitespace-nowrap min-w-40 rounded py-1 bg-blue-cerulean hover-hover:hover:bg-blue-darkish active:bg-blue-darkish active:shadow-active text-base leading-loose text-center
          font-semibold text-white"
          class:lg:min-w-0={reducedPadding}
          onclick={handleTextCardButtonClicked}
          data-testid="{dataTestId}-text-card-button"
        >
          {textCardButtonText}
        </button>
        <button
          class="whitespace-nowrap min-w-40 rounded py-1 bg-blue-cerulean hover-hover:hover:bg-blue-darkish active:bg-blue-darkish active:shadow-active text-base leading-loose text-center
          font-semibold text-white"
          class:lg:min-w-0={reducedPadding}
          onclick={handleEmailCardButtonClicked}
          data-testid="{dataTestId}-email-card-button"
        >
          {emailCardButtonText}
        </button>
      </div>
      <div
        class="w-full mx-auto max-w-85 text-base leading-loose text-center gap-4 lg:max-w-64 lg:grid lg:grid-cols-2"
        class:mb-6={disclaimer} 
        class:hidden={!expanded} 
        class:grid={expanded}
        class:lg:ml-8={!reducedPadding}
      >
        <BaseLink
          className="leading-loose w-full rounded shadow bg-white relative pseudo-shadow-hover active:shadow-active block py-1 lg:pt-2 text-blue-navy font-semibold
           lg:bg-transparent lg:text-blue-cerulean lg:text-sm lg:shadow-none lg:no-pseudo-shadow lg:hover:underline lg:hover:text-blue-navy"
          url={appStoreLink}
          onClick={() => window.umami.track('get-savings-card', { type: 'app' })}
        >
          {openInAppLink.text}
        </BaseLink>
        <button
          class="w-full rounded shadow bg-white relative pseudo-shadow-hover active:shadow-active block py-1 lg:pt-2 text-blue-navy font-semibold
            lg:bg-transparent lg:text-blue-cerulean lg:text-sm lg:shadow-none lg:no-pseudo-shadow lg:hover:underline lg:hover:text-blue-navy"
          onclick={print}
          data-testid="{dataTestId}-print-card-button"
        >
          {printCardLinkText}
        </button>
      </div>
      <button
        class="mb-4 lg:hidden text-blue-cerulean hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:text-blue-darkish active:underline"
        onclick={toggle}
        data-testid="{dataTestId}-{expanded ? 'fewer' : 'more'}-options-button"
      >
        <svg class="h-4 w-4 inline mr-1 fill-current" role="presentation">
          <use xlink:href="{SPRITESHEET_URL}#{expanded ? 'minus' : 'plus'}-sign" />
        </svg>
        <span class="text-xs leading-normal font-semibold">
          {expanded ? fewerOptionsButtonText : moreOptionsButtonText}
        </span>
      </button>
    </div>    
    {#if disclaimer}
      <div 
        class="text-left text-sm leading-tight text-gray-warm lg:col-span-3"
        class:lg:text-center={!reducedPadding}
        class:lg:pt-4={!reducedPadding}
        class:lg:border-t={!reducedPadding}
        class:lg:border-gray-light-silver={!reducedPadding}
      >
        <p class="mx-auto">{disclaimer}</p>
      </div>
    {/if}    
  </div>
</div>
